import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoginPopupsComponent } from './page-login-popups.component';

@NgModule({
  declarations: [PageLoginPopupsComponent],
  imports: [
    CommonModule
  ], exports: [PageLoginPopupsComponent]
})
export class PageLoginPopupsModule { }
